<td
  role="cell"
  class="quick-order-item"
>
  <div class="cx-table-item-container">
    <a
      [ngClass]="{
        disabled: loading,
        'img-missing': !entry?.product?.images?.PRIMARY
      }"
      [routerLink]="{ cxRoute: 'product', params: entry?.product } | cxUrl"
      tabindex="-1"
    >
      <cx-media 
        *ngIf="(entry?.product.servicePart && entry?.product.images?.PRIMARY) || !entry?.product.servicePart; else spGearThumb" 
        [container]="entry?.product?.images?.PRIMARY"
        [alt]="entry?.product?.name"
        format="cartIcon"
        role="presentation">
      </cx-media>
      <ng-template #spGearThumb>
        <div class="sp-gear-thumb">
          <img src="../../../../../../../../assets/icons/sp_gear_thumb.svg" alt="gear">
        </div>
      </ng-template>
    </a>
    <div class="cx-info">
      <div class="cx-name">
        <a
          [ngClass]="{ disabled: loading }"
          [routerLink]="{ cxRoute: 'product', params: entry?.product } | cxUrl"
          class="cx-link"
        >
          {{ entry?.product?.name || "-" }}
        </a>
      </div>
      <div class="cx-code">
        {{
          (entry?.product?.servicePart ? "quickOrderTable.idPart" : "quickOrderTable.id")
            | cxTranslate
              : {
                  id: entry?.product?.displayModelNumber
                    ? entry?.product?.displayModelNumber
                    : entry?.product?.code
                }
        }}
      </div>
      <div *ngIf="entry?.product?.servicePart" class="product-badges-icons">
        <gen-sp-icons [product]="entry?.product" [changeTooltipPosition]="true" [showGreenCheck]="onHand"></gen-sp-icons>
      </div>
    </div>
  </div>
</td>

<td
  role="cell"
  class="cx-price"
>
  <div class="cx-mobile-header">
    {{ "quickOrderTable.itemPrice" | cxTranslate }}
  </div>
  <div *ngIf="netPrice || noNetPrice; else loadingSpinner" class="cx-value">
    <ng-container *ngIf="entry?.product?.purchasable || (!entry?.product?.purchasable && !entry?.product?.purchaseRestrictedByScopeRules)">
      <div [attr.aria-label]="'productSummary.newItemPrice' | cxTranslate" class="price">
        <h3>{{ netPrice | currency : currency }}</h3>
        <span *ngIf="netPrice" class="net">NET</span>
      </div>
    </ng-container>
    <div class="price-msr">
      {{ entry?.basePrice?.formattedValue || "-" }}
      <span class="quick-order-item__msrp">
        {{ (entry?.product?.servicePart ? "quickOrderTable.mslp" : "quickOrderTable.msrp") | cxTranslate }}
      </span>
    </div>
  </div>
  <ng-template #loadingSpinner>
    <div class="cx-spinner">
      <cx-spinner></cx-spinner>
    </div>
  </ng-template>
</td>
<td
  role="cell"
  class="cx-quantity"
>
  <div class="cx-mobile-header">
    {{ "quickOrderTable.qty" | cxTranslate }}
  </div>
  <div class="cx-value">
    <gen-item-counter
      [allowZero]="false"
      [control]="quantityControl"
      [max]="+entry.product?.maxOrderQuantity"
      [min]="+entry.product?.minOrderQuantity"
      [readonly]="loading"
      [step]="+entry.product?.addToCartQtyMultiplier"
      messagePosition="position-right"
    ></gen-item-counter>
  </div>
</td>
<td
  role="cell"
  class="cx-actions"
>
  <button
    (click)="removeEntry()"
    [attr.aria-label]="'common.remove' | cxTranslate"
    [disabled]="loading"
    class="link cx-action-link"
  >
    {{ "common.remove" | cxTranslate }}
  </button>
</td>
